<template>
  <button
    :class="{
      'ph-button': true,
      ['ph-button--'+type]: true,
      ['ph-button--'+size]: true,
      'ph-button--full': isFull
    }"
    :disabled="disabled"
    @click="onClick"
  >
    <slot></slot>
  </button>
</template>
<script>
export default {
  name: 'PhButton',
  props: {
    type: {
      type: String,
      required: false,
      default: 'default' // default, primary
    },
    size: {
      type: String,
      required: false,
      default: 'medium' // large, medium, small
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isFull: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick(...args) {
      if (!this.disabled) {
        this.$emit('click', ...args);
      }
    }
  }
}
</script>
